import RegistrationFailed from "./RegistrationFailed.mp3";
import SpeakChipRegistered from "./SpeakChipRegistered.mp3";
import SpeakMainScreenInstructions from "./SpeakMainScreenInstructions.mp3";
import SpeakPickupConfirmed from "./SpeakPickupConfirmed.mp3";
import SpeakPickupInstructions from "./SpeakPickupInstructions.mp3";
import SpeakPickupItemsFromBox from "./SpeakPickupItemsFromBox.mp3";
import SpeakPickupItemsFromBoxes from "./SpeakPickupItemsFromBoxes.mp3";
import SpeakRegisteringChip from "./SpeakRegisteringChip.mp3";
import SpeakWaitingForChip from "./SpeakWaitingForChip.mp3";
import InvalidCode from "./InvalidCode.mp3";
import NoDelivery from "./NoDelivery.mp3";

export const accessibilitySoundsEn = {
    RegistrationFailed,
    SpeakChipRegistered,
    SpeakMainScreenInstructions,
    SpeakPickupConfirmed,
    SpeakPickupInstructions,
    SpeakPickupItemsFromBox,
    SpeakPickupItemsFromBoxes,
    SpeakRegisteringChip,
    SpeakWaitingForChip,
    InvalidCode,
    NoDelivery
};
